import React, { useCallback, useEffect, useRef, useState } from "react";
import { useResizeScreen } from "../../hooks/useResizeScreen";
import clsx from "clsx";
import AppBar from "@material-ui/core/AppBar";
import Toolbar from "@material-ui/core/Toolbar";
import Drawer from "@material-ui/core/Drawer";
import CssBaseline from "@material-ui/core/CssBaseline";
import List from "@material-ui/core/List";
import { Divider, Box, Dialog, DialogContent } from "@material-ui/core";
import EventAvailableIcon from '@mui/icons-material/EventAvailable';

import IconButton from "@material-ui/core/IconButton";

import ClickAwayListener from '@material-ui/core/ClickAwayListener';

/* Icons */
import HomeOutlinedIcon from '@material-ui/icons/HomeOutlined';
import NotesIcon from "@material-ui/icons/Notes";
import PersonIcon from "@material-ui/icons/Person";

import useStyles from "../../assets/styles/styles";
import { Link, useHistory } from "react-router-dom";
import { AuthConsumer } from "../../auth/providers/authProvider";
import LogoutIcon from '@material-ui/icons/Logout';
import logo from "../../assets/images/logo.png";
import ModalLogOut from "./ModalLogOut";

import { useDispatch, useSelector } from "react-redux";
import ItemMenu from "./ItemMenu";
import Typography from "@material-ui/core/Typography";
import { getFullData } from "../../redux/actions/personalDataActions";
import { CircularProgress } from "@mui/material";
import ModalCommunication from "../DialogCommunication/ModalCommunication";
import DropdownCommunication from "./DropdownCommunication";
import { verifyTypeOfUser,verifyRegister } from "../../redux/actions/registerUsersActions";
import ModalProfileMedico from "./ModalProfileMedico";
import { getCommunication } from "../../redux/actions/communicatedAction";
import {  InvalidUsercode, logoutPersonNumber } from "../../utils/utilsFunctions";

const userCode = parseInt(window.localStorage.getItem("numeroPersona"));

const MenuProfile = () => {
  const dispatch = useDispatch();
  const configurationReduxState = useSelector(state => state.configurationReducer?.allConfigurations?.configurations);
  const classes = useStyles();
  const { screen } = useResizeScreen();
  const [openLogout, setOpenLogout] = useState();
  const communicated = useSelector((state) => state.communicatedReducer.communication);
  const personalDataReducer = useSelector(state => state.personalDataReducer);
  const history = useHistory();
  const drawerOpenerRef = useRef();
  const [type, setType] = useState("");
  const [dni, setDni] = useState("");
  const [birthDate, setbirthDate] = useState(new Date());
  const [openCommunicationModal, setOpenCommunicationModal] = useState(false);
  const [open, setOpen] = useState(true);
  const [openProfile, setOpenProfile] = useState(); 
  const userTypeValidation = useSelector(
    (state) => state.registerUsersReducer.userTypeValidation
  );
  
  const registerReduxState = useSelector((state) => state.registerUsersReducer);
  const registerValidation = useSelector(
    (state) => state.registerUsersReducer.registerValidation
  );

  
  useEffect(() => {
    if (personalDataReducer?.fullData?.afiliado?.documentos != undefined) {
      setType(personalDataReducer?.fullData?.afiliado?.documentos?.[0]?.documentoTipoCodigo)
      setDni(personalDataReducer?.fullData?.afiliado?.documentos?.[0]?.documentoNumero)
      setbirthDate(personalDataReducer?.fullData?.afiliado?.fechaNacimiento)
    }

  }, [personalDataReducer?.fullData?.afiliado?.documentos])


  useEffect(() => {
    const email = window.localStorage.getItem("email");
    const tipoDocumento = window.localStorage.getItem("tipoDocumento");
    const nroDocumento = window.localStorage.getItem("nroDocumento");
    const fechaNacimiento = window.localStorage.getItem("fechaNacimiento");

    const request = {
      tipoDocumento: tipoDocumento || type,
      nroDocumento: nroDocumento || dni,
      fechaNacimiento: fechaNacimiento || birthDate,
      mail: email
    };
    dispatch(verifyRegister(request));
    dispatch(verifyTypeOfUser(request));
  }, []);


  useEffect(() => {
    const hasSeenCommunicationModal = localStorage.getItem('hasSeenCommunicationModal');
    if (!hasSeenCommunicationModal && communicated?.communication?.some(item => item?.status === 1 && item?.modal === 1 &&
      new Date(item.initialDate) <= new Date() && new Date(item.finalDate) >= new Date())) {
      setOpenCommunicationModal(true);
      localStorage.setItem('hasSeenCommunicationModal', 'true');
    }
  }, [communicated]);


  



  useEffect(() =>{
    dispatch(getCommunication())
  },[])

  

  const handleProfile = () => {    
    const { estado } = registerReduxState?.registerValidation;
  
    if (estado !== "ACTIVO") {
      setOpenProfile(prevState => !prevState);
    } else {
      window.location.replace("/");
    }
  };




  const communicationModal = () => {
    return (
      <div>
        {communicated?.communication
          ?.filter(item => item?.status === 1 && item?.modal === 1)
          .map((item, i) => (
            <ModalCommunication
              key={i} 
              type='cancel'
              index={i}
              count={item?.count}
              open={openCommunicationModal}
              onClose={setOpenCommunicationModal}
              close={true}
              description={
                <div>
                  <Typography  className={classes.communicationTitleStyles} >
                    {item?.title}
                  </Typography>
  
                  <Typography className={classes.communicationDescriptionStyle} >
                    {item?.description}
                  </Typography>
                  {item?.image64 && (
                    <img
                      alt={item?.title}
                      src={item?.image64}
                      style={{ width: '100%', height: 'auto', marginTop: '10px' }}
                    />
                  )}
                </div>
              }
            />
          ))}
      </div>
    );
  };
    
 
  const DrawerOpen = useCallback(() => {
    setOpen(prevState => !prevState);
  }, [open]);

  const handleClickAway = () => {
    if (screen.sWidth <= 768) {
      setOpen(false);
    }
  };

  const listItems = (
    <List>
      <AuthConsumer>
        {({ isAuthenticated }) => {
          if (!isAuthenticated()) {
            return (<>
              <ItemMenu Link={Link} Titulo="Inicio" Icon={<HomeOutlinedIcon />} Redirect="/"></ItemMenu>
              <Divider classes={{ root: classes.divider }} />
            </>);
          }
        }
        }
      </AuthConsumer>
      <AuthConsumer>
        {({ isAuthenticated }) => {
          if (isAuthenticated() && !!localStorage.getItem("access_token")) {
            if (InvalidUsercode(userCode)) {
              return null;
            }
            return (
              <>
                <ItemMenu Titulo="Agenda Médica"   Redirect='/CalendarMedical' Icon={<EventAvailableIcon />}></ItemMenu>
                </>
            );
          }
        }}
              </AuthConsumer>

    </List >
  );

  const handleClickLogOut = () => {
    setOpenLogout(prevState => !prevState);
  };

  if (document.getElementById('loadingDiv')) {
      document.getElementById('loadingDiv')?.remove();
  }
  

  useEffect(() => {
    const { registerValidation } = registerReduxState || {};

    if (registerValidation?.numeroPersona) {
      window.localStorage.setItem("numeroPersona", registerValidation?.numeroPersona);
    }
  }, [registerValidation?.numeroPersona]); 


  useEffect(() => {
    let numberPerson = window.localStorage.getItem("numeroPersona");
    if (numberPerson) {
      dispatch(getFullData({ numeroPersona: numberPerson }));
    }
  }, []);

  useEffect(() => {
    if (screen.sWidth <= 768) {
      setOpen(false);
    } else {
      setOpen(true);
    }
  }, [screen.sWidth]);


  return (
    <>
      {communicationModal()}

      <div className={classes.root}>
        <CssBaseline />
        <ClickAwayListener
      onClickAway={handleClickAway}
    >
        <AppBar
          position="fixed"
          elevation={0}
          className={clsx(classes.appBar, { [classes.appBarShift]: open })}
        >
          <Toolbar className={`${classes.toolbar}`}>
            {screen.sWidth <= 768 &&
              <IconButton
                ref={drawerOpenerRef}
                color="inherit"
                maria-label="open drawer"
                onClick={DrawerOpen}
                edge="start"
                className={clsx(classes.menuButton, open)}
              >
                <NotesIcon />
              </IconButton>
            }
            <AuthConsumer>
              {({ isAuthenticated }) => {
                  if (isAuthenticated() && !!localStorage.getItem("access_token")) {
                    if (InvalidUsercode(userCode)) {
                      logoutPersonNumber();
                      return null;
                    }
                    return (
                    <>
                      <div className={classes.divHeaderLogo}>
                        <IconButton onClick={() => { history.push('/MedicalProfile'); }}>
                          <img style={{ height: '90px' }} src={logo} alt="logo" />
                        </IconButton>
                      </div>
                      <section className={`${classes.rightSectionMenu}`}>
                        {screen.sWidth > 768 &&
                          <article style={{ display: 'flex', flex: '1 1 100%', flexWrap: 'wrap', paddingRight: '20px' }}>
                            <Typography style={{ color: 'black', width: '100%', justifyContent: 'flex-end', display: 'flex' }}>
                              {window.localStorage.getItem("userName").replace("_", " ")}
                            </Typography>
                          </article>
                        }
                        <DropdownCommunication />
                        {(userTypeValidation?.perfil === "AFILIADO-MEDICO" || userTypeValidation?.perfil === "EXTERNO-MEDICO") &&  (
                            <IconButton
                              edge='start'
                              className={classes.menuButtonRight}
                              color='inherit'
                              onClick={handleProfile}
                            >
                              <PersonIcon style={{ flex: '1 1 100%',marginLeft:"-7px" }} />
                              <span style={{marginLeft:"-7px"}} className={classes.txtLogIn}>Medico</span>
                            </IconButton>
                          )}
                        <IconButton
                          style={{marginLeft:"-7px"}}
                          edge="start"
                          className={classes.menuButtonRight}
                          color="inherit"
                          onClick={handleClickLogOut}
                        >
                          <LogoutIcon />
                        </IconButton>
                      </section>
                    </>
                  );
                } else {
                  return (
                    <>
                    <div className={classes.divHeaderLogo}>
                    <IconButton onClick={() => { history.push('/'); }}>
                        <img style={{ height: '90px', marginLeft:"-20px"}} src={logo} alt="logo" />
                      </IconButton>
                    </div>
                     
                      {
                        configurationReduxState !== undefined ?
                          <IconButton
                            edge='start'
                            className={classes.menuButtonRight}
                            color='inherit'
                            component={Link}
                            to={'/login'}>
                            <PersonIcon style={{ flex: '1 1 100%' }} />
                            <span className={classes.txtLogIn}>Iniciar Sesion</span>
                          </IconButton>
                        :
                          <CircularProgress size={40} style ={{marginLeft:"40px"}}sx={{ color: '#fff', marginRight: '30px' }} />
                      }
                    </>);
                }
              }}
            </AuthConsumer>
          </Toolbar>
        </AppBar>
        </ClickAwayListener>
        <Drawer
          className={`${classes.drawerMenu}`}
          variant="persistent"
          anchor="left"
          open={open}
          classes={{ paper: `${classes.drawerPaperMenu} ${classes.customScroll}` }}
        >
          {listItems}
        </Drawer>
      </div>
      <ModalLogOut isOpen={openLogout} setOpen={setOpenLogout} />
      <ModalProfileMedico isOpen={openProfile} setOpen={setOpenProfile} />
    </>
  );
};

export default MenuProfile;
